import { Component, EventEmitter, input, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { Product, ProductAttribute, TreeNodeDecl } from '@app/shared/_models/product';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule }      from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { SearchProductComponent } from "@app/shared/search-product/search-product.component";
import { Observable, Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ProductTplService } from '@app/sales/product-tpl/productTpl.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';






export interface FlatNode {
  val_name: string;
  atribute_name: string;
  val_name_combine: string; // atribute_name with combinatoire values appended
  combinatoire: number[];
  isLeaf: boolean;
  level: number;
  product?: Product  ;
}

@Component({
  selector: 'app-tree-node-decl',
  templateUrl: './tree-node-decl.component.html',
  styleUrls: ['./tree-node-decl.component.scss'],
  imports: [MatFormFieldModule, MatInputModule, RouterLink, SearchProductComponent, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class TreeNodeDeclComponent {
	constructor(private productTplService: ProductTplService) { }

  // @Input({ required: true }) nodes: TreeNodeDecl[] = [];
	@Input() loadProductTplEventsSubject$!: Observable<FormGroup>;				// Parent productTpl was loaded
	@Output("updateProductAttributeValues") updateProductAttributeValues: EventEmitter<any> = new EventEmitter();	// To send submit to parent

  private maxLevel = 3; // deepest level in the tree for setting label column width in order to align input fields (second column of the grid)
	private eventsSubscription!: Subscription;
  
  public formGroup!: FormGroup;
  public treenodedecl: TreeNodeDecl[] = [];

	private productSubscription!: Subscription;


  public flatNodes: FlatNode[] = [];
  public indentStep = 45;  // pixels per level of indentation inside the tree
  public inputwidthPx = 240; // width of input fields in pixels
  public labelColPx = this.maxLevel * this.indentStep + 45; // initial value of label column width in pixels will be updated in ngOnChanges
  


  	ngOnInit(): void {
    this.eventsSubscription = this.loadProductTplEventsSubject$.subscribe((formGroup: FormGroup) => { 	// Triggered on productTpl loading
			this.formGroup = formGroup;
      this.treenodedecl = this.buildCartesianTreeDecl(this.formGroup.get("lnk_product_attributes")?.value, this.indexProductsByCombinatoire(this.formGroup.get("lnk_products")?.value));
      this.flatNodes = [];
      //  console.log('Variable : this.treenodedecl', this.treenodedecl);
      if (this.treenodedecl?.length) {
          for (const node of this.treenodedecl) {
            this.flattenNode(node, '',  0);
          }
        }
      
      // console.log('Variable : this.formGroup', this.formGroup);
    });
    // console.log('Variable : this.flatNodes', this.flatNodes);

    
	}

  
  selectProduct(product: Product, node: FlatNode){
    console.log('Variable : node', node);
    console.log('Variable : product', product);
    console.log('Variable : this.formGroup.get("id")?.value', this.formGroup.get("id")?.value);
    console.log('Variable : product', product);
    if (! (this.formGroup.get("id")?.value) || !product || !product.id) return;
    this.productSubscription = this.productTplService.postAttachProductToTemplate( this.formGroup.get("id")?.value , product.id , node.combinatoire)
    .subscribe((retour) => {
        console.log(' after attache ', retour );
        this.updateProductAttributeValues.emit()
      });
  }
  
  detachProduct(product: Product){
    console.log('Variable : product', product);
    console.log('Variable : this.formGroup.get("id")?.value', this.formGroup.get("id")?.value);
    if ( !product || !product.id) return;
    this.productSubscription = this.productTplService.postDetachProductFromTemplate( product.id)
      .subscribe((retour) => {
        console.log(' after detach  data  : ',retour );
        if(retour && retour.data && retour.data.dettach ) {  // every things is ok we reload
          this.updateProductAttributeValues.emit()
        }
      });
  }


  // ngOnChanges(): void {
  //   this.flatNodes = [];
  //   if (this.nodes?.length) {
  //     for (const node of this.nodes) {
  //       this.flattenNode(node, '',  0);
  //     }
  //   }
  //   this.maxLevel = Math.max(0, ...this.flatNodes.map(n => n.level));
  //   this.maxLevel++;
  //   this.labelColPx = this.maxLevel * this.indentStep + 50;
  //   // console.log('this.maxLevel',this.maxLevel);
  //   // console.log('this.labelColPx',this.labelColPx);
  //   // console.log('this.flatNodes',this.flatNodes);
    
  // }

  // Fonction récursive 
  buildCartesianTreeDecl(   attributes: ProductAttribute[],   productMap: Map<string, Product>,   depth: number = 0,   combinatoire: number[] = [],   parentNames: string = "" ): TreeNodeDecl[] {
    if (depth >= attributes.length) return [];
    // console.log('Variable : attributes', attributes);
    const currentAttr = attributes[depth];
    const nodes: TreeNodeDecl[] = [];
    const isLastLevel = ( depth === attributes.length - 1 ) ;
    
    for (const val of currentAttr.lnk_product_attribute_vals) {
      // console.log('Variable : val', val);
      const newCombinatoire = [...combinatoire, val.pav_id];
      const newParentNames = parentNames  ? `${parentNames} - ${val.pav_name}`  : val.pav_name;
      
      const node: TreeNodeDecl = {
        atribute_name: currentAttr.name,
        attribute: currentAttr.id,
        id: val.pav_id,
        val_name: val.pav_name,
        val_name_combine: newParentNames,
        seq: val.pav_seq,
        combinatoire: newCombinatoire,
        children: this.buildCartesianTreeDecl(   attributes,   productMap,   depth + 1,   newCombinatoire,   newParentNames ),
      };
      
      // Si on est au dernier niveau, on récupère le produit via la Map
      if (isLastLevel) {
        const key = this.createCombinatoireKey(newCombinatoire);
        node.product = productMap.get(key) || null;
      }
      
      nodes.push(node);
    }
    return nodes;
  }

    // Fonction pour créer une clé unique à partir d'une combinaison d'attributs
  createCombinatoireKey(combinatoire: number[]): string {
    return combinatoire.sort((a, b) => a - b).join('-');
  }


  // Fonction pour indexer les produits par leur combinaison d'attributs
  indexProductsByCombinatoire(products: Product[]): Map<string, Product> {
    const productMap = new Map<string, Product>();
    for (const product of products) {
      // Extraire les IDs des valeurs d'attributs du produit
      // console.log('Variable : product', product);
      const attrValIds = (product.lnk_attributes?.map((attr) => attr.pav_id) ?? [0]) ; // array de tous les attributes id ex plus id=59 et small id=41  retourne [59,41]
      // console.log('Variable : attrValIds', attrValIds);
      const key = this.createCombinatoireKey(attrValIds); // retourn une string ordonné dans le cas précédent : 41-59  qui du coup sera unique
      // console.log('Variable : key', key);
      productMap.set(key, product);
    }
    // console.log('productMap',productMap);
    return productMap;
  }


  private flattenNode(node: TreeNodeDecl, parent_val_name: string,  level: number): void {
    const isLeaf = !node.children || node.children.length === 0;
    this.flatNodes.push({
      val_name: node.val_name,
      atribute_name: node.atribute_name,
      val_name_combine: node.val_name_combine,
      combinatoire: node.combinatoire,
      isLeaf,
      level,
      product: node.product || undefined
    });

    if (!isLeaf) {
      for (const child of node.children) {
        this.flattenNode(child, node.val_name, level + 1);
      }
    }
  }


  ngOnDestroy(): void {
    this.eventsSubscription.unsubscribe();
    if (this.productSubscription) this.productSubscription.unsubscribe();
  }


}
